import Vue from 'vue'
import Router from 'vue-router'
import umsRoutes from './module/umsRoutes'
import cmsThreadRoutes from './module/cmsThreadRoutes'
import cmsUniversityInfoRoutes from './module/cmsUniversityInfoRoutes'
import cmsAlbumRoute from './module/cmsAlbumRoute'
import cmsAcademyRoute from './module/cmsAcademyRoute'
import cmsBannerRoute from './module/cmsBannerRoute'
import cmsScoreline from './module/cmsScoreline'
import cmsLuqu from './module/cmsLuqu'
import cmsAd from './module/cmsAd'
import umsMemberRoute from './module/umsMemberRoute'
import sysSettingRoute from './module/sysSettingRoute'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'home' }
    }]
  },
]

export const asyncRouterMap = [
  cmsUniversityInfoRoutes,
  cmsThreadRoutes,
  cmsAlbumRoute,
  cmsBannerRoute,
  cmsAcademyRoute,

  cmsScoreline,
  cmsLuqu,
  cmsAd,
  umsMemberRoute,
  umsRoutes,
  sysSettingRoute,
  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js